function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { DeviceType } from '@sky-uk-ott/client-lib-js-device';
import { MseWrapManager } from '../../../addons/tools/mse-wrap/mse-wrap-manager';
import { StreamProxy } from '../../../addons/tools/stream-proxy/stream-proxy';
import { CoreVideoInternal } from '../../../core-video-internal';
import { sdkLogger } from '../../../logger';
import { Observable } from '../../../utils/observables/observable';
import { PerfKey, perfLogger, PerfTag } from '../../../utils/perf';
import { PlaybackType } from '../../player/playout-data';
import { VideoColourSpace } from '../../player/video-format';
import { StaticAsset } from '../asset';
import { PeacockStreamingFormatProxy } from '../../video-platform-integration/psf-proxy';
export var VideoStartupEngineStarter = /*#__PURE__*/ function() {
    "use strict";
    function VideoStartupEngineStarter(sessionItem, videoStartupEngineStarterOptions) {
        _class_call_check(this, VideoStartupEngineStarter);
        var _this_videoStartupEngineStarterOptions_sessionConfig_addons_streamProxy, _this_videoStartupEngineStarterOptions_sessionConfig_addons, _this_videoStartupEngineStarterOptions_sessionConfig_addons_mseWrap, _this_videoStartupEngineStarterOptions_sessionConfig_addons1;
        _define_property(this, "sessionItem", void 0);
        _define_property(this, "videoStartupEngineStarterOptions", void 0);
        _define_property(this, "peiPrecursorErrorsObservable", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "peiPrecursor", void 0);
        _define_property(this, "streamProxy", void 0);
        _define_property(this, "_mainAsset", void 0);
        this.sessionItem = sessionItem;
        this.videoStartupEngineStarterOptions = videoStartupEngineStarterOptions;
        this.peiPrecursorErrorsObservable = new Observable();
        this.logger = sdkLogger.withContext('Precursor');
        if ((_this_videoStartupEngineStarterOptions_sessionConfig_addons = this.videoStartupEngineStarterOptions.sessionConfig.addons) === null || _this_videoStartupEngineStarterOptions_sessionConfig_addons === void 0 ? void 0 : (_this_videoStartupEngineStarterOptions_sessionConfig_addons_streamProxy = _this_videoStartupEngineStarterOptions_sessionConfig_addons.streamProxy) === null || _this_videoStartupEngineStarterOptions_sessionConfig_addons_streamProxy === void 0 ? void 0 : _this_videoStartupEngineStarterOptions_sessionConfig_addons_streamProxy.enabled) {
            var streamProxyConfig = this.videoStartupEngineStarterOptions.sessionConfig.addons.streamProxy.config;
            perfLogger.measure(PerfKey.streamProxy, PerfTag.addonInstantiationStart);
            this.streamProxy = new StreamProxy(streamProxyConfig);
            perfLogger.measure(PerfKey.streamProxy, PerfTag.addonInstantiationEnd);
        }
        var addonsFactories = CoreVideoInternal.getPropositionExtensions().addonFactories;
        if ((_this_videoStartupEngineStarterOptions_sessionConfig_addons1 = this.videoStartupEngineStarterOptions.sessionConfig.addons) === null || _this_videoStartupEngineStarterOptions_sessionConfig_addons1 === void 0 ? void 0 : (_this_videoStartupEngineStarterOptions_sessionConfig_addons_mseWrap = _this_videoStartupEngineStarterOptions_sessionConfig_addons1.mseWrap) === null || _this_videoStartupEngineStarterOptions_sessionConfig_addons_mseWrap === void 0 ? void 0 : _this_videoStartupEngineStarterOptions_sessionConfig_addons_mseWrap.enabled) {
            new MseWrapManager(this.videoStartupEngineStarterOptions.sessionProxy, addonsFactories, this.sessionItem);
        }
    }
    _create_class(VideoStartupEngineStarter, [
        {
            key: "mainAsset",
            get: function get() {
                return this._mainAsset;
            }
        },
        {
            key: "onPeiPrecursorErrorsObservable",
            value: function onPeiPrecursorErrorsObservable(callback) {
                this.peiPrecursorErrorsObservable.registerObserver(callback, this);
            }
        },
        {
            key: "unregisterPeiPrecursorErrorsObservable",
            value: function unregisterPeiPrecursorErrorsObservable() {
                this.peiPrecursorErrorsObservable.unregisterObservers(this);
            }
        },
        {
            key: "buildPeiPrecursor",
            value: function buildPeiPrecursor(playoutData) {
                var _this_videoStartupEngineStarterOptions_playerPrecursorEngine;
                return (_this_videoStartupEngineStarterOptions_playerPrecursorEngine = this.videoStartupEngineStarterOptions.playerPrecursorEngine) === null || _this_videoStartupEngineStarterOptions_playerPrecursorEngine === void 0 ? void 0 : _this_videoStartupEngineStarterOptions_playerPrecursorEngine.createPlayerItemPrecursor(playoutData, this.videoStartupEngineStarterOptions.advertsManager.getAdvertBoltOns(), this.videoStartupEngineStarterOptions.drmBoltons, this.sessionItem, this.videoStartupEngineStarterOptions.engineCreationOptions);
            }
        },
        {
            key: "startEngine",
            value: function startEngine(modifiedPlayoutData, isPrefetching) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_videoStartupEngineStarterOptions_advertsManager_getAdInsertionConfig, _this_peiPrecursor_attachPlayerErrorsHandler, _this_peiPrecursor, isCsai, isDolbyVisionOnXbox, _this_peiPrecursor1;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.streamProxy) {
                                    modifiedPlayoutData = _this.streamProxy.modifyPlayout(modifiedPlayoutData);
                                }
                                if (_this.sessionItem.enablePeacockStreamingFormatOverride) {
                                    modifiedPlayoutData = PeacockStreamingFormatProxy.getModifiedPlayoutData(modifiedPlayoutData);
                                }
                                if (_this.videoStartupEngineStarterOptions.pineManager) {
                                    modifiedPlayoutData = _this.videoStartupEngineStarterOptions.pineManager.getModifiedPlayoutData(modifiedPlayoutData);
                                }
                                _this._mainAsset = new StaticAsset(modifiedPlayoutData);
                                if (!isPrefetching) {
                                    _this.peiPrecursor = _this.buildPeiPrecursor(modifiedPlayoutData);
                                    return [
                                        2,
                                        modifiedPlayoutData
                                    ];
                                }
                                isCsai = (_this_videoStartupEngineStarterOptions_advertsManager_getAdInsertionConfig = _this.videoStartupEngineStarterOptions.advertsManager.getAdInsertionConfig()) === null || _this_videoStartupEngineStarterOptions_advertsManager_getAdInsertionConfig === void 0 ? void 0 : _this_videoStartupEngineStarterOptions_advertsManager_getAdInsertionConfig.isTimelineAdManagementRequired;
                                if (!_this.videoStartupEngineStarterOptions.playerPrecursorEngine || // Shouldn't be prefetching if there's no player precursor engine!
                                isCsai) // Prefetching is not valid for CSAI
                                {
                                    return [
                                        2,
                                        Promise.resolve(undefined)
                                    ];
                                }
                                if (!modifiedPlayoutData) {
                                    return [
                                        2,
                                        Promise.resolve(undefined)
                                    ];
                                }
                                _this.peiPrecursor = _this.buildPeiPrecursor(modifiedPlayoutData);
                                if (!_this.peiPrecursor) {
                                    return [
                                        2,
                                        Promise.resolve(undefined)
                                    ];
                                }
                                if (modifiedPlayoutData.type === PlaybackType.Live || modifiedPlayoutData.type === PlaybackType.SingleLiveEvent) {
                                    return [
                                        2,
                                        Promise.resolve(undefined)
                                    ];
                                }
                                // TODO - move this into player capabilities
                                isDolbyVisionOnXbox = modifiedPlayoutData.stream.colourSpace === VideoColourSpace.DV && (CoreVideoInternal.deviceType === DeviceType.XboxOne || CoreVideoInternal.deviceType === DeviceType.XboxSeries);
                                if (isPrefetching && isDolbyVisionOnXbox) {
                                    return [
                                        2,
                                        Promise.resolve(undefined)
                                    ];
                                }
                                (_this_peiPrecursor_attachPlayerErrorsHandler = (_this_peiPrecursor = _this.peiPrecursor).attachPlayerErrorsHandler) === null || _this_peiPrecursor_attachPlayerErrorsHandler === void 0 ? void 0 : _this_peiPrecursor_attachPlayerErrorsHandler.call(_this_peiPrecursor, function() {
                                    _this.peiPrecursorErrorsObservable.notifyObservers();
                                });
                                if (!isPrefetching) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (_this_peiPrecursor1 = _this.peiPrecursor) === null || _this_peiPrecursor1 === void 0 ? void 0 : _this_peiPrecursor1.prefetch()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    modifiedPlayoutData
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createPlayerEngineItem",
            value: function createPlayerEngineItem(engine, modifiedPlayoutData, advertBoltOns, drmBoltOns) {
                var sessionId = this.videoStartupEngineStarterOptions.sessionId;
                var isPlayoutWithMatchingPrecursor = this.peiPrecursor && sessionId && modifiedPlayoutData.sessionId === sessionId;
                var precursor = isPlayoutWithMatchingPrecursor ? this.peiPrecursor : undefined;
                var pei = engine.createPlayerItem(modifiedPlayoutData, advertBoltOns, drmBoltOns, this.sessionItem, precursor);
                if (isPlayoutWithMatchingPrecursor) {
                    this.peiPrecursor = undefined;
                }
                return pei;
            }
        },
        {
            key: "teardownPlayer",
            value: function teardownPlayer() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_peiPrecursor_detachPlayerErrorsHandler, _this_peiPrecursor, message;
                    return _ts_generator(this, function(_state) {
                        if (_this.peiPrecursor) {
                            try {
                                ;
                                (_this_peiPrecursor_detachPlayerErrorsHandler = (_this_peiPrecursor = _this.peiPrecursor).detachPlayerErrorsHandler) === null || _this_peiPrecursor_detachPlayerErrorsHandler === void 0 ? void 0 : _this_peiPrecursor_detachPlayerErrorsHandler.call(_this_peiPrecursor);
                                _this.peiPrecursor.destroy();
                                _this.logger.verbose('PEI Precursor Destroyed');
                            } catch (e) {
                                message = "Error while destroying PEI Precursor: ".concat(e);
                                _this.logger.warn(message, e);
                                throw new Error("PRECURSOR_PEIP.DESTROY: ".concat(message));
                            }
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.peiPrecursorErrorsObservable.unregisterObservers(this);
                this._mainAsset = undefined;
                this.teardownPlayer();
            }
        }
    ]);
    return VideoStartupEngineStarter;
}();

//# sourceMappingURL=video-startup-engine-starter.js.map